import { useEffect } from "react";

const useParentBlurListener = (ref: React.RefObject<HTMLElement>, onParentBlur: () => void, dependencies: any[] = []) => {
    
    useEffect(() => {
        ref.current.addEventListener('focusout', (event) => {
            const leavingParent = !ref.current.contains(event.relatedTarget as any);

            if (leavingParent) {
                onParentBlur()
            }
        }, true)
    }, dependencies)
}

export default useParentBlurListener
    
